"use client";

import {JSX} from "react";

import {useTranslation} from "@/shared/i18n";
import {Typography} from "@/shared/ui/data-display/typography";

import {WEEKDAY_KEYS} from "../constants";

interface CalendarWeekdaysProps {
    weekdays?: ReadonlyArray<string>; // Translation keys from model (e.g., ["sun", "mon", ...] or ["mon", "tue", ...])
}

export function CalendarWeekdays({weekdays}: CalendarWeekdaysProps): JSX.Element {
    const {t} = useTranslation("calendar");

    // Use weekdays from model if provided, otherwise fallback to default (Monday first)
    const weekdayKeys = weekdays && weekdays.length === 7 ? weekdays : WEEKDAY_KEYS;

    return (
        <div className="daterange-picker-field__weekdays">
            {weekdayKeys.map((key) => (
                <Typography
                    key={key}
                    as="div"
                    size={12}
                    weight={600}
                    color="paragraph"
                    options={["uppercase"]}
                    className="daterange-picker-field__weekday"
                >
                    {t(key as Parameters<typeof t>[0])}
                </Typography>
            ))}
        </div>
    );
}
